import React from "react";
import { Button } from "react-bootstrap";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiInput } from "../../../components/form/UiInput";

export const GiftPoints = () => {
    return (
        <>
            <div className="sb-g-points">
                <UiCardTitle title="Gift Points" />

                <UiContentCol>

                    <h5>Add handle of the person you would like to gift points to</h5>
                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                    <div className="sb-g-points__sb-gift-input-card">
                        <UiInput
                            placeholder="Enter members’ email or handle here"
                            type="text" />
                        <Button >Search </Button>
                    </div>

                    <div className="sb-g-points__sb-gift-input-card">
                        <UiInput
                            placeholder="Points Total"
                            type="text" />
                        <Button >Gift Now </Button>
                    </div>

                </UiContentCol>
            </div>
        </>
    )
}